import { EventName } from "@/api/event/common";
import NiceModal from "@ebay/nice-modal-react";

import { useBeforeSetting } from "@/store/beforeSetting";
import EventMgr from "@/utils/EventMgr";
import useDialog from "@/utils/useDialog";
import React, {
  memo,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import UpdateBanblce from "../webSocket/updateBanblce/UpdateBanblce";
import {
  useWsError,
  useWsLoginOut,
  useWsOpenWallet,
  useWsRefreshSettings,
} from "@/store/hallSocket";
import {
  useGlobalCurrentWallet,
  useGlobalState,
  useGlobalTheme,
  usePleryBets,
  useUpdateGlobalOriginalBalance,
} from "@/store/commonStore";
import {
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from "react-router";
import { getTimestamp } from "@/Core/utils";
import { useExitGame } from "@/store/game";
import { useVipInfo } from "@/store/PersonalCenter";
import { useUserInfo } from "@/store/userInfo";
import { useGetLoginSpecialActivityData } from "@/store/loginSpecialActivity";
import { sys } from "@/Core/utils/system";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import useDialogManager from "@/utils/useDialogManager";
import CommonPopup from "@/pages/commonPopup";
import { useDispatch } from "react-redux";
import { enqueue } from "@/features/modalOrchestrator";
import { logoutEmUser, syncEmUserFromAuth } from "@/features/analytics/em/sdk";

import { isString } from "@/utils/is";
import { IFInitWalletRsp } from "@/api/apiRsp/IFWalletRsp";
import { SocketPackTool } from "@/Core/net/socket/SocketPackTool";
import { Lobby } from "@/proto/Lobby";
import { feedback } from "@/utils/feedback";
import "./index.less";
const routesMap = {};

const CommonEventCompoent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, tokenTime, setToken, setTokenTime, isLogin } =
    useGlobalState();
  const { close } = useDialog();
  const { data, mutate } = useBeforeSetting();
  const { t } = useTranslationPlus();
  useWsRefreshSettings();
  const { data: insufficientBalanceData } = useWsOpenWallet();
  useWsLoginOut();
  useWsError();
  const { theme } = useGlobalTheme();
  const loginOutRef = useRef<boolean>();
  const prevIsLoginRef = useRef<boolean>(isLogin);
  const { openWallet } = useDialogManager();
  const [gameBetData, setGameBetData] = useUpdateGlobalOriginalBalance();
  const [currentWalletGlobal, setCurrentWalletGlobal] =
    useGlobalCurrentWallet();
  const [playerBets, setPlayerBets] = usePleryBets();
  const betNotifyTargetRef = useRef(Symbol());
  const userInfoRef = useRef(null);
  const currentWalletRef = useRef(null);
  const playerBetsRef = useRef(null);

  /**处理401|登出 */
  const handleLoginout401 = () => {
    if (isLogin && !loginOutRef.current) {
      loginOutRef.current = true;
      setToken("");
      setTokenTime("");
      close();
      navigate("/home");
    }
  };

  useEffect(() => {
    isLogin && (loginOutRef.current = false);
  }, [isLogin]);

  /**处理停服 */
  const handleStopServer = () => {
    mutate();
  };

  /**处理错误弹窗 */
  const handleErrorPop = (response: any) => {
    console.log(response);
  };

  const showUpdate = useRef(false);

  useEffect(() => {
    if (data && data.wnoticeVO) {
      dispatch(
        enqueue({
          id: "stop_service",
          type: "stop_service",
          priority: 50,
          dedupeKey: "stop_service",
          sessionOnceKey: "stop_service",
          payload: {},
        }),
      );
    }
    if (
      data &&
      data.appVersion &&
      data.appVersion > process.env.REACT_APP_VERSION &&
      !showUpdate.current
    ) {
      showUpdate.current = true;
      const id = `${Date.now()}`;
      setTimeout(() => {
        feedback.notification.info({
          id,
          title: t("UPDATE_WEBSITE_TITLE"),
          content: t("UPDATE_WEBSITE_CONTENT"),
          duration: 0,
          actionText: t("UPDATE_NOW"),
          onAction: () => {
            feedback.notification.remove(id);
            showUpdate.current = false;
            window.location.reload();
          },
        });
      }, 1000);
    }
  }, [data]);

  /**统一处理登录刷新数据 */
  const { revalidate } = useVipInfo(false);
  const { revalidate: revalidateUserInfo, data: userInfo } = useUserInfo();
  const { revalidate: revalidateSpecialActivityData } =
    useGetLoginSpecialActivityData();

  useEffect(() => {
    if (isLogin) {
      revalidate();
      //revalidateAmount()
      revalidateUserInfo();
      revalidateSpecialActivityData();
    }
  }, [isLogin]);

  useEffect(() => {
    EventMgr.getInstance().removeByEvent(EventName.LOGIN_OUT_401);
    EventMgr.getInstance().removeByEvent(EventName.STOP_SERVER_111);
    EventMgr.getInstance().removeByEvent(EventName.ERROR_POP_DIALOG);

    EventMgr.getInstance().addEventListener(
      EventName.LOGIN_OUT_401,
      handleLoginout401,
      this
    );
    EventMgr.getInstance().addEventListener(
      EventName.STOP_SERVER_111,
      handleStopServer,
      this
    );
    EventMgr.getInstance().addEventListener(
      EventName.ERROR_POP_DIALOG,
      handleErrorPop,
      this
    );

    return () => {
      EventMgr.getInstance().removeByEvent(EventName.LOGIN_OUT_401);
      EventMgr.getInstance().removeByEvent(EventName.STOP_SERVER_111);
      EventMgr.getInstance().removeByEvent(EventName.ERROR_POP_DIALOG);
    };
  }, [isLogin]);

  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  useEffect(() => {
    if (isLogin && userInfo) {
      syncEmUserFromAuth(userInfo.userId, userInfo);
    }
  }, [isLogin, userInfo]);

  useEffect(() => {
    if (prevIsLoginRef.current && !isLogin) {
      logoutEmUser();
    }

    prevIsLoginRef.current = isLogin;
  }, [isLogin]);

  useEffect(() => {
    currentWalletRef.current = currentWalletGlobal;
  }, [currentWalletGlobal]);

  useEffect(() => {
    playerBetsRef.current = playerBets;
  }, [playerBets]);

  useEffect(() => {
    SocketPackTool.register(
      function (pack, code): void {
        if (code !== 200) {
          return;
        }
        if (
          !userInfoRef.current?.userId ||
          `${pack?.userId}` !== `${userInfoRef.current?.userId}`
        ) {
          return;
        }

        const playerAmount = Number(pack?.playerAmount);
        if (Number.isFinite(playerAmount)) {
          setGameBetData({
            winAmount: Number(pack?.winAmount || 0),
            playerAmount,
            currencyType: pack?.currencyType,
          });
        }
        const canUpdateBalance = Number.isFinite(playerAmount) && playerAmount > 0;

        if (
          canUpdateBalance &&
          currentWalletRef.current &&
          (currentWalletRef.current.currencyType === pack?.currencyType ||
            currentWalletRef.current.serverCurrencyType === pack?.currencyType)
        ) {
          setCurrentWalletGlobal({
            ...currentWalletRef.current,
            allBalance: playerAmount,
          });
        }

        if (playerBetsRef.current && Array.isArray(playerBetsRef.current)) {
          setPlayerBets([pack, ...playerBetsRef.current]);
        } else {
          setPlayerBets([pack]);
        }
      },
      Lobby.LobbyPacketID.PACKET_MC_BET_GAME_NOTIFY,
      Lobby.Lobby.BetGameNotifyMc,
      betNotifyTargetRef.current
    );

    return () => {
      SocketPackTool.unregister(
        Lobby.LobbyPacketID.PACKET_MC_BET_GAME_NOTIFY,
        betNotifyTargetRef.current
      );
    };
  }, []);

  useEffect(() => {
    const handleVisiblity = () => {
      if (document.visibilityState == "visible") {
        mutate();
      }
    };

    document.addEventListener("visibilitychange", handleVisiblity);
    //

    return () => {
      document.removeEventListener("visibilitychange", handleVisiblity);
    };
  }, []);

  // useEffect(() => {
  //   changeTheme(theme);
  // }, [theme]);

  //useVipInfo();
  useEffect(() => {
    const checkToken = () => {
      if (!token || token.length < 5) {
        return false;
      }
      return true;
      // const delta = getTimestamp() - Number(tokenTime);
      // if (delta > 0 && delta < 86400) {
      //   return true;
      // } else {
      //   return false;
      // }
    };

    if (!checkToken()) {
      setToken("");
      setTokenTime("");
    }
  }, []);
  let currencyType = null;
  let precisionCurrencyType = null;
  useEffect(() => {
    if (currentWalletGlobal && !currencyType) {
      currencyType = currentWalletGlobal.currencyType;
      precisionCurrencyType =
        currentWalletGlobal.serverCurrencyType || currentWalletGlobal.currencyType;
      window.addEventListener("message", (event) => {
        if (event.data === "openOwnerWallet") {
          openWallet({ isHideClose: true });
        } else {
          //判断小游戏postmessage
          try {
            const dataJson = event.data;
            // const dataJson = isString(event.data) ? JSON.parse(event.data) : event.data;
            if (dataJson.name == "x-game") {
              switch (dataJson.key) {
                case "fixInsufficientBalance":
                  openWallet({ isHideClose: true });
                  break;
                case "fixSize":
                  //dataJson.name
                  //dataJson.height
                  break;
                case "fixBalance":
                  //dataJson.name
                  //dataJson.balance
                  //dataJson.payment

                  setGameBetData({
                    /**赢取金额 */
                    winAmount:
                      (window.currencyPrecision[precisionCurrencyType] / 100) *
                      dataJson.payment,
                    /**玩家当前余额 */
                    playerAmount:
                      (window.currencyPrecision[precisionCurrencyType] / 100) *
                      dataJson.balance,
                    /**当前币种 */
                    currencyType: currencyType,
                  });

                  break;
                case "fixNotLogin":
                  //dataJson.name
                  break;
              }
            }
          } catch (ex) {
            console.log("Can not parse PostMessage", ex);
          }
        }
      });
    }
  }, [currentWalletGlobal]);
  useEffect(() => {
    if (insufficientBalanceData) {
      NiceModal.show(CommonPopup, {
        ontentText: t("Wallet.InsufficientBalance"),
        rightBtnText: t("GameOriginal.Confirm"),
        leftBtnText: t("GameOriginal.Cancle"),
        leftCallback: ({ remove }) => {
          remove();
        },
        rightCallback: ({ remove }) => {
          remove();
          openWallet({ isHideClose: true });
        },
      });
    }
  }, [insufficientBalanceData]);

  //退出游戏
  const { exitTrigger } = useExitGame();
  const { pathname } = useLocation();

  const firstEnterAppRef = useRef(null);

  useEffect(() => {
    if (
      !firstEnterAppRef.current &&
      isLogin &&
      pathname &&
      !pathname.includes("game")
    ) {
      firstEnterAppRef.current = true;
      exitTrigger({});
    }
  }, [isLogin, pathname]);

  const types = useNavigationType();
  useLayoutEffect(() => {
    if (types === "PUSH") {
      document.documentElement.scrollTop = 0;
    }
  }, [types, pathname]);

  return (
    <>
      {/**处理ws金额推送 */}
      <UpdateBanblce />
    </>
  );
};

export default memo(CommonEventCompoent);
